export default __webpack_public_path__ + "static/media/headset4.7c1cba6e.jfif";